import { NEW_BEST_RING_S } from '../audio/sfx';
import { must, replayAnimation, setVisible } from './dom';

/** The operator readout across the top of the board. */
export const hud = {
  setTowers(placed: number, par: number): void {
    must('towerCount').textContent = Number.isFinite(par) ? `${placed} / ${par}` : `${placed}`;
  },

  setHouses(lit: number, total: number): void {
    must('houseCount').textContent = `${lit} / ${total}`;
  },

  setMegawatts(mw: number | null): void {
    must('mwCount').textContent = mw === null ? '–' : String(mw);
    // delivered output is live circuit — the readout's one amber value
    must('mwChip').classList.toggle('live', mw !== null);
  },

  setStreak(days: number | null): void {
    const chip = must('streakChip');
    setVisible(chip, days !== null && days > 0);
    if (days !== null && days > 0) {
      must('streakCount').textContent = String(days);
    }
  },

  /** Shake the tower readout when the player is out of towers. */
  flashTowerLimit(): void {
    replayAnimation(must('towerChip'), 'shake');
  },

  /**
   * Flash the delivered-MW readout when a new best lands — for exactly as
   * long as the `newBest` cue rings, published as --best-flash (one clock).
   */
  flashNewBest(): void {
    const chip = must('mwChip');
    chip.style.setProperty('--best-flash', `${NEW_BEST_RING_S}s`);
    replayAnimation(chip, 'best-flash');
  },
};
